module.exports = __webpack_public_path__ + "img/advertiser-login-as.8266b2dd.svg";